import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ITableSelectionEvent, ITableSelectRangeEvent, IDataTableAdapter } from '../../interfaces';
import { MatDialog } from '@angular/material/dialog';
import { ModalCreateErrorComponent } from '../modal-create-error/modal-create-error.component';
import { ContentDialogGenericComponent } from '../content-dialog-generic/content-dialog-generic.component';
import { ErrorReportService } from '../../../tvf/errors-manager/services/errors.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-table-errors-manager',
  templateUrl: './table-errors.component.html',
  styleUrls: ['./table-errors.component.sass', './table-errors.component.scss'],
})
export class TableErrorsManagerComponent implements OnInit {
  columns: Array<any>;
  modalColumns: Array<any>;
  displayedColumns: Array<any>;
  dataSource = new MatTableDataSource<any>([]);
  selection = new SelectionModel<any>(true, []);
  serverPagination: any;
  @Input() pageSizeOptions: number[] = [10, 25, 50, 100];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<any>;

  @Output() tradeReprocess: EventEmitter<any> = new EventEmitter<any>();
  @Output() batchReprocess: EventEmitter<any[]> = new EventEmitter<any[]>();

  @Input() enablePagination = true;
  @Input() enableSelection = true;
  @Input() selectedAllDefault = false;

  @Input() set dataAdapter(value: IDataTableAdapter) {
    this.buildDataAdpater(value);
  }

  @Output() rowChanged: EventEmitter<ITableSelectionEvent> =
    new EventEmitter<ITableSelectionEvent>();
  @Output() rangeChanged: EventEmitter<ITableSelectRangeEvent> =
    new EventEmitter<ITableSelectRangeEvent>();
  @Output() pageChanged = new EventEmitter<any>();
  @Input() refreshTable;
  constructor(
    private dialog: MatDialog,
    private errorReportService: ErrorReportService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    if (this.selectedAllDefault) {
      this.masterToggle();
    }
  }

  buildDataAdpater(value: IDataTableAdapter) {
    this.columns = value.columns
      .filter((c) => c.show)
      .map((column: { key: string | number; label: string; ellipsis?: number }) => ({
        columnDef: column.key,
        header: column.label,
        ellipsis: column.ellipsis,
        cell: (element: any) => `${element[column.key] != null && element[column.key] !== '' ? element[column.key] : '-'}`,
      }));
    this.modalColumns = value.columns;
    this.displayedColumns = this.columns.map((c) => c.columnDef);

    if (value.enableAction) {
      this.enableSelection = value.enableAction;
      this.displayedColumns.push('action');
    }

    this.dataSource = new MatTableDataSource(value.dataSource);
    this.serverPagination = value.pagination;

    this.pageSizeOptions = value.pageSizeOptions || [10, 25, 50, 100];
  }

  isAllSelected() {
    const numRows = this.dataSource.data.length;
    const numSelected = this.selection.selected.length;
    return numSelected === numRows;
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      this.rangeChanged.emit({ isSelected: false, elements: this.dataSource.data });
    } else {
      this.dataSource.data.forEach((element) => this.selection.select(element));
      this.rangeChanged.emit({ isSelected: true, elements: this.dataSource.data });
    }
  }

  manipulateSelections(event: any, element: any) {
    this.rowChanged.emit({ isSelected: event.checked, element });
    const result = event.checked
      ? this.selection.toggle(element)
      : this.selection.deselect(element);
  }

  showErrorDetail(error: any) {
    const dataDialog = {
      title: `${error.status}`,
      error,
      columns: this.modalColumns,
      refreshTable: this.refreshTable,
    };
    const dialogRef = this.dialog.open(ModalCreateErrorComponent, {
      width: '100%',
      maxWidth: '80vw',
      maxHeight: '90vh',
      autoFocus: false,
      data: dataDialog,
      panelClass: 'custom-mat-dialog',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.refreshTable?.();
      }
      this.pageChanged.emit({
        currentPage: this.serverPagination.currentPage,
        pageSize: this.serverPagination.pageSize,
      });
    });
  }

  deleteErrorDialog(error: any) {
    const dataDialog = {
      message: `Você está removendo o erro "${error.errorText}". Deseja continuar?`,
      title: 'Remover erro',
      buttons: {
        primaryText: 'Remover',
        primaryColor: 'warn',
        secondaryText: 'Cancelar',
        secondaryColor: 'primary',
      },
    };

    const dialogRef = this.dialog.open(ContentDialogGenericComponent, {
      data: dataDialog,
      width: '650px',
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.errorReportService.deleteError(error.errorId).subscribe({
          next: () => {
            this.toastr.success('Erro removido com sucesso!');
            this.refreshTable?.();
            this.pageChanged.emit({
              currentPage: this.serverPagination.currentPage,
              pageSize: this.serverPagination.pageSize,
            });
          },
          error: (err) => {
            this.toastr.error(err.errors?.[0] || 'Ocorreu um erro ao remover, tente novamente mais tarde.');
          },
        });
      }
    });
  }

  doReprocess(element: any) {
    this.selection.clear();
    this.tradeReprocess.emit(element);
  }
  doBatchReprocess() {
    this.batchReprocess.emit(this.selection.selected);
    this.selection.clear();
  }

  handlePageEvent(e: PageEvent) {
    this.selection.clear();
    this.pageChanged.emit({ currentPage: e.pageIndex + 1, pageSize: e.pageSize });
  }
}
